var touchstartX = 0;
var touchstartY = 0;
var touchendX = 0;
var touchendY = 0;

var gesuredZone = document.getElementById('sidenavContent');

gesuredZone.addEventListener('touchstart', function (event) {
    touchstartX = event.changedTouches[0].screenX;
    touchstartY = event.changedTouches[0].screenY;
}, false);

gesuredZone.addEventListener('touchend', function (event) {
    touchendX = event.changedTouches[0].screenX;
    touchendY = event.changedTouches[0].screenY;
    handleGesure();
}, false);


// gesuredZone.addEventListener('mousedown', function (event) {
//     touchstartX = event.screenX;
//     touchstartY = event.screenY;
// }, false);

// gesuredZone.addEventListener('mouseup', function (event) {
//     touchendX = event.screenX;
//     touchendY = event.screenY;
//     handleGesure();
// }, false);


function handleGesure() {
    let xDiff = Math.max(touchendX, touchstartX) - Math.min(touchendX, touchstartX)
    let yDiff = Math.max(touchendY, touchstartY) - Math.min(touchendY, touchstartY)

    if (touchendX < touchstartX && xDiff > yDiff && xDiff > 150) {
        //left
        document.querySelector('#sidenav').classList.remove('isOpen');
    }
    if (touchendX > touchstartX && xDiff > yDiff && xDiff > 150) {
        //right
        document.querySelector('#sidenav').classList.add('isOpen');
    }
}